import axios from "@axios";

import * as ep from "./endpoints";

export default class Service {
  //   static createRecord(payload) {
  //     return axios.post(ep.RECORD, payload).then(res =>
  //   }
  static fetchPrograms(params) {
    return axios.get(ep.PROGRAMS, { params: { ...params } });
  }

  static saveProgram(data) {
    return axios.post(ep.PROGRAMS, data);
  }

  static fetchProgramById(id) {
    return axios.get(ep.PROGRAM_BY_ID(id)).then((res) => res.data);
  }

  static updateProgram(payload) {
    return axios.put(ep.PROGRAM_BY_ID(payload.id), payload);
  }

  static deleteProgram(payload) {
    return axios.delete(ep.PROGRAM_BY_ID(payload.id));
  }

  static fetchActivities(params) {
    return axios.get(ep.ACTIVITIES, { params: { ...params } });
  }

  static saveActivity(data) {
    return axios.post(ep.ACTIVITIES, data);
  }

  static fetchActivityById(id) {
    return axios.get(ep.ACTIVITY_BY_ID(id)).then((res) => res.data);
  }

  static updateActivity(payload) {
    return axios.put(ep.ACTIVITY_BY_ID(payload.id), payload);
  }

  static deleteActivity(payload) {
    return axios.delete(ep.ACTIVITY_BY_ID(payload.id));
  }
}
